// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-site-design-access-item {
  display: block;
}
.fi-site-design-access-item .site-design-access-items-container {
  position: relative;
  height: 40px;
  cursor: pointer;
}
.fi-site-design-access-item .site-design-access-items-container .site-design-access-item-logo {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid;
}
.fi-site-design-access-item .site-design-access-items-container .site-design-access-item-logo .fi-profile-icon-img {
  box-shadow: none;
}
.fi-site-design-access-item .site-design-access-items-container .site-design-access-item-logo .fi-profile-colored {
  width: 36px;
  height: 36px;
  line-height: 36px;
  background-color: var(--fi-color-white) !important;
  color: inherit;
}
.fi-site-design-access-item .site-design-access-items-container .site-design-access-item-logo {
  position: absolute;
  top: 0;
}
.fi-site-design-access-item .site-design-access-items-container .site-design-access-item-logo:nth-child(1) {
  z-index: 4;
}
.fi-site-design-access-item .site-design-access-items-container .site-design-access-item-logo:nth-child(2) {
  z-index: 3;
}
.fi-site-design-access-item .site-design-access-items-container .site-design-access-item-logo:nth-child(3) {
  z-index: 2;
}
.fi-site-design-access-item .site-design-access-items-container .site-design-access-item-logo:nth-child(4) {
  z-index: 1;
}
.fi-site-design-access-item .site-design-access-items-container .site-design-access-item-logo.additional-badge {
  text-align: center;
  line-height: 38px;
  font-size: 12px;
  border-color: var(--fi-color-dark);
  color: var(--fi-color-dark);
}
.fi-site-design-access-item .fi-info-icon {
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: 5;
}

.tooltip.site-designs-details-list-tooltip {
  border-radius: 4px;
  background-color: var(--fi-color-white) !important;
  pointer-events: none !important;
}
.tooltip.site-designs-details-list-tooltip:after {
  display: none;
}
.tooltip.site-designs-details-list-tooltip .site-design-details-wrapper:not(:last-child) {
  margin-bottom: 10px;
}
.tooltip.site-designs-details-list-tooltip .site-design-details-wrapper .site-design-access-item-logo {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid;
}
.tooltip.site-designs-details-list-tooltip .site-design-details-wrapper .site-design-access-item-logo .fi-profile-icon-img {
  box-shadow: none;
}
.tooltip.site-designs-details-list-tooltip .site-design-details-wrapper .site-design-access-item-logo .fi-profile-colored {
  width: 36px;
  height: 36px;
  line-height: 36px;
  background-color: var(--fi-color-white) !important;
  color: inherit;
}
.tooltip.site-designs-details-list-tooltip .site-design-details-wrapper .fi-profile-icon,
.tooltip.site-designs-details-list-tooltip .site-design-details-wrapper .site-design-access-item-name {
  vertical-align: middle;
}
.tooltip.site-designs-details-list-tooltip .site-design-details-wrapper .site-design-access-item-name {
  margin-left: 5px;
}`, "",{"version":3,"sources":["webpack://./Source/app/fi-site-design/fi-site-design-access-item/fi-site-design-access-item.component.scss"],"names":[],"mappings":"AAmBA;EACI,cAAA;AAlBJ;AAmBI;EACI,kBAAA;EACA,YAAA;EACA,eAAA;AAjBR;AANI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAQR;AAPQ;EACI,gBAAA;AASZ;AAPQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kDAAA;EACA,cAAA;AASZ;AAIQ;EACI,kBAAA;EACA,MAAA;AAFZ;AAGY;EACI,UAAA;AADhB;AAGY;EACI,UAAA;AADhB;AAGY;EACI,UAAA;AADhB;AAGY;EACI,UAAA;AADhB;AAGY;EACI,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,kCAAA;EACA,2BAAA;AADhB;AAKI;EACI,OAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;AAHR;;AAOA;EACI,kBAAA;EACA,kDAAA;EACA,+BAAA;AAJJ;AAKI;EACI,aAAA;AAHR;AAMQ;EACI,mBAAA;AAJZ;AAhEI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAkER;AAjEQ;EACI,gBAAA;AAmEZ;AAjEQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kDAAA;EACA,cAAA;AAmEZ;AATQ;;EAEI,sBAAA;AAWZ;AATQ;EACI,gBAAA;AAWZ","sourcesContent":["@mixin fi-site-design-access-item-logo-base {\r\n    .site-design-access-item-logo {\r\n        width: 40px;\r\n        height: 40px;\r\n        border-radius: 50%;\r\n        border: 2px solid;\r\n        .fi-profile-icon-img {\r\n            box-shadow: none;\r\n        }\r\n        .fi-profile-colored {\r\n            width: 36px;\r\n            height: 36px;\r\n            line-height: 36px;\r\n            background-color: var(--fi-color-white) !important;\r\n            color: inherit;\r\n        }\r\n    }\r\n}\r\n\r\n.fi-site-design-access-item {\r\n    display: block;\r\n    .site-design-access-items-container {\r\n        position: relative;\r\n        height: 40px;\r\n        cursor: pointer;\r\n        @include fi-site-design-access-item-logo-base();\r\n\r\n        .site-design-access-item-logo {\r\n            position: absolute;\r\n            top: 0;\r\n            &:nth-child(1) {\r\n                z-index: 4;\r\n            }\r\n            &:nth-child(2) {\r\n                z-index: 3;\r\n            }\r\n            &:nth-child(3) {\r\n                z-index: 2;\r\n            }\r\n            &:nth-child(4) {\r\n                z-index: 1;\r\n            }\r\n            &.additional-badge {\r\n                text-align: center;\r\n                line-height: 38px;\r\n                font-size: 12px;\r\n                border-color: var(--fi-color-dark);\r\n                color: var(--fi-color-dark);\r\n            }\r\n        }\r\n    }\r\n    .fi-info-icon {\r\n        left: 0;\r\n        top: 0;\r\n        height: 100%;\r\n        width: 100%;\r\n        z-index: 5;\r\n    }\r\n}\r\n\r\n.tooltip.site-designs-details-list-tooltip {\r\n    border-radius: 4px;\r\n    background-color: var(--fi-color-white) !important;\r\n    pointer-events: none !important;\r\n    &:after {\r\n        display: none;\r\n    }\r\n    .site-design-details-wrapper {\r\n        &:not(:last-child) {\r\n            margin-bottom: 10px;\r\n        }\r\n        @include fi-site-design-access-item-logo-base();\r\n        .fi-profile-icon,\r\n        .site-design-access-item-name {\r\n            vertical-align: middle;\r\n        }\r\n        .site-design-access-item-name {\r\n            margin-left: 5px;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
